// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .user_layout_container {
    width: 98%;
    height: 60px;
    position: relative;
  }

  .user_layout_logo_container {
    width: calc(100% - 100px);
    position: absolute;
    left: 50px;
    justify-content: center !important;
  }

  .user_layout_search_container {
    width: 50px;
    position: absolute;
    right: 0px;
  }

  .user_layout_menu_container {
    width: 500px;
    display: none !important;
  }

  .user_layout_drawer_container {
    width: 50px;
    position: absolute;
    left: 0px;
  }

  .non-mobile_screen {
    display: none !important;
  }

  .user_layout_logo {
    width: 200px !important;
    height: 50px !important;
  }

  .drawer_menu_icon {
    height: 25px !important;
    width: 25px !important;
  }
  .search_mobile_icon {
    height: 30px !important;
    width: 30px !important;
  }
  .drawer_menu_container {
    height: 400px;
    width: 100%;
  }
  .header_drawer_social_media_container {
    height: 60px;
  }
  .header_drawer_social_media_wrapper {
    width: 80%;
    height: 60px;
  }
  .header_drawer_social_small_wrapper {
    width: 34%;
    height: 60px;
  }

  .user_layout_menus {
    font-size: 18px;
  }
  .drawer_user_detail_container {
    height: 40px;
    justify-content: flex-start;
    width: 100%;
  }

  .drawer_user_name_text {
    font-size: 18px;
  }

  .quick_access_container {
    display: none !important;
  }
  .user_contribute_stories_main_container {
    display: none !important;
  }
  .footer_mobile_view_container {
    display: none !important;
  }
  .header_drawer_language_text {
    font-size: 18px;
  }
  .breadcrumb_container {
    display: none !important;
  }
  .slot_card_box {
    padding: 20px;
  }
  .header_drawer_close_container {
   
    justify-content: flex-end !important;
   
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_768_1023/screen_768_1023.layout.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;;IAEE,oCAAoC;;EAEtC;;AAEF","sourcesContent":["@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .user_layout_container {\n    width: 98%;\n    height: 60px;\n    position: relative;\n  }\n\n  .user_layout_logo_container {\n    width: calc(100% - 100px);\n    position: absolute;\n    left: 50px;\n    justify-content: center !important;\n  }\n\n  .user_layout_search_container {\n    width: 50px;\n    position: absolute;\n    right: 0px;\n  }\n\n  .user_layout_menu_container {\n    width: 500px;\n    display: none !important;\n  }\n\n  .user_layout_drawer_container {\n    width: 50px;\n    position: absolute;\n    left: 0px;\n  }\n\n  .non-mobile_screen {\n    display: none !important;\n  }\n\n  .user_layout_logo {\n    width: 200px !important;\n    height: 50px !important;\n  }\n\n  .drawer_menu_icon {\n    height: 25px !important;\n    width: 25px !important;\n  }\n  .search_mobile_icon {\n    height: 30px !important;\n    width: 30px !important;\n  }\n  .drawer_menu_container {\n    height: 400px;\n    width: 100%;\n  }\n  .header_drawer_social_media_container {\n    height: 60px;\n  }\n  .header_drawer_social_media_wrapper {\n    width: 80%;\n    height: 60px;\n  }\n  .header_drawer_social_small_wrapper {\n    width: 34%;\n    height: 60px;\n  }\n\n  .user_layout_menus {\n    font-size: 18px;\n  }\n  .drawer_user_detail_container {\n    height: 40px;\n    justify-content: flex-start;\n    width: 100%;\n  }\n\n  .drawer_user_name_text {\n    font-size: 18px;\n  }\n\n  .quick_access_container {\n    display: none !important;\n  }\n  .user_contribute_stories_main_container {\n    display: none !important;\n  }\n  .footer_mobile_view_container {\n    display: none !important;\n  }\n  .header_drawer_language_text {\n    font-size: 18px;\n  }\n  .breadcrumb_container {\n    display: none !important;\n  }\n  .slot_card_box {\n    padding: 20px;\n  }\n  .header_drawer_close_container {\n   \n    justify-content: flex-end !important;\n   \n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
